import { render, staticRenderFns } from "./SpecialUserRights.vue?vue&type=template&id=323f181c&scoped=true"
import script from "./SpecialUserRights.vue?vue&type=script&lang=js"
export * from "./SpecialUserRights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323f181c",
  null
  
)

export default component.exports